import { render } from "./RelatedArticleBox.vue?vue&type=template&id=2d327e98&scoped=true"
import script from "./RelatedArticleBox.vue?vue&type=script&lang=js"
export * from "./RelatedArticleBox.vue?vue&type=script&lang=js"

import "./RelatedArticleBox.vue?vue&type=style&index=0&id=2d327e98&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d327e98"]])

export default __exports__